/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_EyebrowInputs */

const tr_servis_eyebrow = /** @type {(inputs: Servis_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servis Sözleşmesi`)
};

const en_servis_eyebrow = /** @type {(inputs: Servis_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Agreement`)
};

const de_servis_eyebrow = /** @type {(inputs: Servis_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicevertrag`)
};

const ru_servis_eyebrow = /** @type {(inputs: Servis_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервисный договор`)
};

/**
* | output |
* | --- |
* | "Service Agreement" |
*
* @param {Servis_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_eyebrow = /** @type {((inputs?: Servis_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_eyebrow(inputs)
	if (locale === "de") return de_servis_eyebrow(inputs)
	if (locale === "ru") return ru_servis_eyebrow(inputs)
	return tr_servis_eyebrow(inputs)
});